// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import WidgetClassContentItemSchema from './widget-class-content-item-schema';

const schema = {
  $id: '/widget-class-faq-schema',
  type: 'object',
  required: ['order'],
  nullable: true,
  properties: {
    order: {
      type: 'integer',
    },
    title: {
      type: 'string',
      nullable: true,
    },
    content: {
      type: 'array',
      nullable: true,
      items: { ...WidgetClassContentItemSchema },
    },
  },
} as IJSONSchema;

export default schema;
